import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { MdError } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import PrivateApi from "../../services/PrivateApiService";
import AnlageUseStage from "./new_anlage/AnlageUseStage";
import AnlageDataStage from "./new_anlage/AnlageDataStage";
import QuestionRegisterStage from "./new_anlage/QuestionRegisterStage";
import RegisterStage from "./new_anlage/RegisterStage";
import SummaryStage from "./new_anlage/SummaryStage";
import { useAuthState } from "../../context/AuthContext";
import Validator from "../../services/Validator";
import { useQueryClient } from "react-query";
import EmployeeStage from "./new_anlage/EmployeeStage";


const NewEditAnlageModal = ({show, setShow, address, anlage, building}) => {

    const { user, contactPerson } = useAuthState();
    const API = new PrivateApi(); // backend calls
    const VALIDATOR = new Validator();
    const queryClient = useQueryClient();
    const [stage, setStage] = useState("employee"); // change modal view
    const [data, setData] = useState({}); // data of all fields
    const [fieldErrors, setFieldsError] = useState({}); // errors of all fields
    const dateLimit = new Date(); // date comparison 

    // set limit to 14 days to compare
    dateLimit.setDate(dateLimit.getDate() + 14);

    // effect to reset all fields on show
    useEffect(() => {
        if (show) {
            var temp = {};
            if (contactPerson) {
                setStage("default");
            } else {
                setStage("employee");
            }
            temp.street = address.x_studio_field_mNWrb.replace(/\s?$/,'');
            temp.houseNumber = address.x_studio_field_uGpho;
            temp.anlageUse = "";
            temp.anlageUseDesc = "";
            temp.staircase = "";
            temp.top = "";
            temp.bestand = "";
            temp.energyForm = "";
            temp.smartmeter = true;
            temp.secondZaehler = false;
            temp.zaehlerNumber1 = "";
            temp.zaehlerNumber2 = "";
            temp.zaehlerLocation = "";
            temp.register = false;
            temp.asLeerstand = false;
            temp.registerDate = "";
            temp.zaehlerstand1 = "";
            temp.zaehlerstand2 = "";
            temp.useMtu = false;
            temp.mtuName = "";
            temp.mtuDirect = false;
            temp.cardHolder = "";
            temp.iban = "";
            temp.mtuPaysOverTransfer = false;

            setData(temp);
        }
    }, [show])


    // next button handler 
    const nextBtnHandler = () => {
        var nextStage = "";
        var temp = {};
        setFieldsError({});
        
        // check fields 
        if (stage === "default") {
            nextStage = "anlage_data";
            if (data.street === "") temp.street = true;
            if (data.houseNumber === "") temp.houseNumber = true;
            if (data.anlageUse === "") temp.anlageUse = true;
            if (data.anlageUse === "Allgemeine Liegenschaftsteile" && data.anlageUseDesc === "") temp.anlageUseDesc = true;
            if ((data.anlageUse === "Wohnung" || data.anlageUse === "Gewerbe") && data.top === "") temp.top = true;
            if ((data.anlageUse === "Wohnung" || data.anlageUse === "Gewerbe") && user.x_bestandseinheitennummer_required && data.bestand === "") temp.bestand = true;
        }
        if (stage === "anlage_data") {
            nextStage = "question_register";
            if (data.energyForm === "") temp.energyForm = true;
            if (data.zaehlerNumber1.length < 4) temp.zaehlerNumber1 = true;
            if (data.secondZaehler === true && data.zaehlerNumber2.length < 4)  temp.zaehlerNumber2 = true;
            if (data.energyForm === "Gas") setData((prev) => ({...prev, smartmeter: false}));
        }
        if (stage === "register_data") {
            nextStage = "summary";
            if (data.registerDate === "") temp.registerDate = true;
            if (data.useMtu === true && data.mtuName === "") temp.mtuName = true;
            if (data.useMtu === true && data.mtuDirect === true && data.mtuPaysOverTransfer === false && data.cardHolder === "") temp.cardHolder = true;
            if (data.useMtu === true && data.mtuDirect === true && data.mtuPaysOverTransfer === false && data.iban === "") temp.iban = true;
            if (data.useMtu === true && data.mtuDirect === true && data.mtuPaysOverTransfer === false && VALIDATOR.ibanValid(data.iban.replace(/\s+/g, '')) === false) temp.iban = true;
            if (data.smartmeter === false && new Date(data.registerDate) < dateLimit && data.zaehlerstand1 === "") temp.zaehlerstand1 = true;
            if (data.smartmeter === false && new Date(data.registerDate) < dateLimit &&  isNaN(data.zaehlerstand1)) temp.zaehlerstand1 = true;
            if (data.smartmeter === false && data.secondZaehler === true && new Date(data.registerDate) < dateLimit && data.zaehlerstand2 === "") temp.zaehlerstand2 = true;
            if (data.smartmeter === false && data.secondZaehler === true && new Date(data.registerDate) < dateLimit && isNaN(data.zaehlerstand2)) temp.zaehlerstand2 = true;
            if (data.smartmeter === false && new Date(data.registerDate) < dateLimit && !VALIDATOR.IsZaehlerstand(data.zaehlerstand1)) temp.zaehlerstand1 = true;
            if (data.smartmeter === false && data.secondZaehler === true && new Date(data.registerDate) < dateLimit && !VALIDATOR.IsZaehlerstand(data.zaehlerstand2)) temp.zaehlerstand2 = true;
        }

        if (Object.keys(temp).length > 0) {
            return setFieldsError(temp);
        }
        return setStage(nextStage);
    }


    // function to send data to backend
    const sendDataHandler = () => {
        setStage("loading");
        data.building = building;
        var storedContact = localStorage.getItem('contactPerson');
        if (storedContact) {
            data.contact = JSON.parse(storedContact);
        }

        API.hw_Anlagen_new(data)
            .then(() => {
                setStage("success");
                queryClient.invalidateQueries("GET_ALL_BUILDING_INFO_QUERY");
            })
            .catch(() => {
                setStage("error");
            })
    }


    return (
        <Modal show={show} size="xl">
            <Modal.Header closeButton onHide={() => setShow(false)}>
                <Modal.Title>
                    {anlage === undefined? "Anlage zum Gebäude hinzufügen": `Anlage ${anlage.x_studio_field_mWMGR} ändern`}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    stage === "employee"?
                    <>
                        <EmployeeStage setStage={setStage} setShow={setShow} />
                    </>:

                    stage === "default"?
                    <>
                        <p className="text-energo">Anlagenadresse</p>
                        <AnlageUseStage data={data} setData={setData} errors={fieldErrors} setErrors={setFieldsError} />
                    </>:
                    
                    stage === "anlage_data"?
                    <>
                        <p className="text-energo">Anlagendaten</p>
                        <AnlageDataStage data={data} setData={setData} errors={fieldErrors} setErrors={setFieldsError} />
                    </>:

                    stage === "question_register"?
                    <>
                        <QuestionRegisterStage setStage={setStage} setData={setData} />
                    </>:

                    stage === "register_data"?
                    <>
                        <p className="text-energo">Anmeldedaten</p>
                        <RegisterStage data={data} setData={setData} errors={fieldErrors} setErrors={setFieldsError} />
                    </>:

                    stage === "summary" ?
                    <>
                        <h5>Ihre Zusammenfassung</h5>
                        <SummaryStage data={data} />
                    </>:

                    stage === "loading"?
                    <>
                        <div className="text-center">
                            <h5>Daten werden übermittelt...</h5>
                            <Spinner animation="grow" className="text-energo"/> &nbsp;
                            <Spinner animation="grow" className="text-energo"/> &nbsp;
                            <Spinner animation="grow" className="text-energo"/>
                        </div>
                    </>:
                    
                    stage === "success"?
                        <div className="text-center">
                            <h5 className="text-energo">Daten übermittelt</h5>
                            <FaCheckCircle size={50} className="mt-3 text-energo" />
                            <p className="mt-4">Anlagendaten wurden an ENERGO gesendet und werden in Kürze verarbeitet.</p>
                        </div>:

                    stage === "error" ?
                        <div className="text-center">
                            <h5 className="text-danger">Fehler aufgetreten</h5>
                            <MdError size={50} className="text-danger mt-3" />
                            <p className="mt-4">Leider ist beim Hinzufügen der Anlagen ein Fehler aufgetreten. Bitte kontaktieren Sie den Support, wenn der Fehler erneut auftritt.</p>
                        </div>:
                    null
                }
            </Modal.Body>
            <Modal.Footer>
                <div className="text-end">
                    {
                        stage === "default"?
                            <>
                                <Button onClick={() => setShow(false)} className="btn-warning" style={{marginRight: "10px"}}>Abbrechen</Button>
                                <Button onClick={() => nextBtnHandler()} className="btn-energo">Weiter</Button>
                            </>:
                        stage === "anlage_data"?
                            <>
                                <Button onClick={() => setStage("default")} className="btn-warning" style={{marginRight: "10px"}}>Zurück</Button>
                                <Button onClick={() => nextBtnHandler()} className="btn-energo">Weiter</Button>
                            </>:
                        stage === "register_data"?
                            <>
                                <Button onClick={() => setStage("question_register")} className="btn-warning" style={{marginRight: "10px"}}>Zurück</Button>
                                <Button onClick={() => nextBtnHandler()} className="btn-energo">Weiter</Button>
                            </>:    
                        stage === "summary"?
                            <>
                                <Button onClick={() => setStage("question_register")} className="btn-warning" style={{marginRight: "10px"}}>Zurück</Button>
                                <Button onClick={() => sendDataHandler()} className="btn-energo">Absenden</Button>
                            </>:
                        stage === "success"?
                            <Button onClick={() => setShow(false)} className="btn-energo">Schließen</Button>
                        :
                        stage === "error" ?
                            <>
                                <Button onClick={() => setShow(false)} className="btn-warning" style={{marginRight: "10px"}}>Abbrechen</Button>
                                <Button onClick={() => sendDataHandler()} className="btn-energo">Erneut versuchen</Button>
                            </>
                        :
                        null
                    }
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default NewEditAnlageModal;